import React, { useEffect } from "react";
import { Dots } from "react-activity";
import "react-activity/dist/Dots.css";

interface Props { size?: "sm" | "md" | "lg", loadingText?: string }

export const Loading: React.FC<Props> = (props) => {

  const [timedOut, setTimedOut] = React.useState(false);

  const getContents = () => {
    const text = (props.loadingText) ? props.loadingText : "Loading"
    if (timedOut) return (<p>Request timed out.  Please try again.</p>);
    let result = <><Dots speed={0.8} animating={true} size={32} /><p>{text}</p></>
    switch (props.size) {
      case "sm":
        result = <><Dots speed={0.8} animating={true} size={20} /><p style={{ fontSize: 12 }}>{text}</p></>
        break;
      case "lg":
        result = <><Dots speed={0.8} animating={true} size={48} /><p style={{ fontSize: 30 }}>{text}</p></>
        break;
    }
    return result;
  }

  useEffect(() => {
    const timer = setTimeout(() => { setTimedOut(true); }, 10000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div style={{ textAlign: "center", fontFamily: "Roboto" }}>
      {getContents()}
    </div>
  )
}